import * as React from "react";

class PreviewPopover extends React.Component<any, any> {
  render() {
    return (
      <div>
        <p>
          <strong>Preview:</strong> As you select metrics and dimensions a
          preview of your
          <br />
          file's headers will appear below. You can change the order of the{" "}
          <br />
          columns by dragging the metric and dimension tiles above.
        </p>
      </div>
    );
  }
}

export default PreviewPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportStructure/PreviewPopover.tsx